module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal9-db0713b6e18409fdc919d291226ed3ca.jpg";